import { gql } from 'apollo-boost'

// export const SAVE_EVENT = gql`
//   mutation saveEvent(
//     $userId: ID
//     $quizId: ID
//     $categoryId: ID
//     $questionId: ID
//     $seconds: Int
//     $selectedAnswerIndex: Int
//     $isCorrect: Boolean
//     $points: Int
//     $type: String
//     $productId: ID
//     $description: String
//     $action: ID
//     $videoUrl: String
//   ) {
//     event: createEvent(
//       event: {
//         userId: $userId
//         quizId: $quizId
//         categoryId: $categoryId
//         questionId: $questionId
//         seconds: $seconds
//         selectedAnswerIndex: $selectedAnswerIndex
//         isCorrect: $isCorrect
//         points: $points
//         type: $type
//         productId: $productId
//         description: $description
//         action: $action
//         videoUrl: $videoUrl
//       }
//     ) {
//       userId
//       quizId
//       questionId
//       selectedAnswerIndex
//       seconds
//       isCorrect
//       categoryId
//       points
//       type
//       productId
//       description
//       action
//     }
//   }
// `

export const AUTHENTICATE_USER = gql`
  mutation AuthUser($accessToken: String, $adId: String) {
    user: saveUser(accessToken: $accessToken, adId: $adId) {
      id
      uid
      accessToken
      picture
      name
      phoneNumber
      email
      newTourCompleted
    }
  }
`

// export const CALCULATE_RESULT = gql`
//   mutation CalculateQuizResult($userId: ID!, $quizId: ID, $timeSpent: Int) {
//     result: calculateResult(
//       userId: $userId
//       quizId: $quizId
//       timeSpent: $timeSpent
//     ) {
//       id
//       percentScore
//       correctAnswers
//       totalQuestions
//       timeSpent
//       userId
//       quizId
//     }
//   }
// `

export const UPDATE_USER = gql`
  mutation UpdateUser($userId: ID!, $user: UserInput!) {
    profile: updateUser(id: $userId, user: $user) {
      id
      name
      phoneNumber
    }
  }
`

export const UPDATE_USER_AGE = gql`
  mutation UpdateUser($id: ID!, $age: String!) {
    profile: updateUserAge(id: $id, age: $age) {
      id
      newChildAge
      OnboardingComplete
    }
  }
`

export const UPDATE_VIDEO_DATA = gql`
  mutation($userId: ID!, $videoId: ID!, $percentage: Int!) {
    updateVideoStatus(
      userId: $userId
      videoId: $videoId
      percentage: $percentage
    ) {
      watched
    }
  }
`
// export const SUBMIT_QUIZ_QUES_RESULT=gql`
// mutation submitQuizQuestion($userId:ID!,$correct:!String,$selectedIndex:Int){
//   updateQuizJourney(userId:$userId,correct:$correct,selectedIndex:$selectedIndex){
//     questionNumber
//   }
// }
// `

// export const SUBMIT_QUIZ_QUES_RESULT=gql`
//   mutation submitQuizResult($userId:ID!,$correct:Boolean!,$selectedIndex:Int!){
//     updateQuizJourney(userId:$userId,correct:$correct,selectedIndex:$selectedIndex){
//       questionNumber
//     }
//   }
// `

export const SUBMIT_QUIZ_QUES_RESULT = gql`
  mutation submitQuizResult(
    $userId: ID!
    $selectedIndex: Int!
    $correct: Boolean!
  ) {
    updateQuizJourney(
      userId: $userId
      selectedIndex: $selectedIndex
      correct: $correct
    ) {
      questionNumber
      selectedIndex
    }
  }
`

export const CREATE_OTP = gql`
  mutation CreateOtp($phoneNumber: String!, $login: Boolean!) {
    otp: generateOtp(phoneNumber: $phoneNumber, login: $login) {
      phoneNumber
      otp
      otpLimitReached
    }
  }
`

export const VERIFY_OTP = gql`
  mutation VerifyOtp($phoneNumber: String!, $otp: String!) {
    authResult: verifyOtp(phoneNumber: $phoneNumber, otp: $otp)
  }
`

export const CREATE_REWARD = gql`
  mutation CreateReward($user: ID, $product: ID, $stage: Stage) {
    reward: createReward(
      reward: { user: $user, product: $product, stage: $stage }
    ) {
      user
      product
      stage
    }
  }
`

export const SUBMIT_WORKSHEET = gql`
  mutation submitWorkSheet($userId: ID!, $sheetId: ID!, $answer: [String!]!) {
    updateSheetJourney(userId: $userId, sheetId: $sheetId, answer: $answer) {
      success
      completed
    }
  }
`

export const SUBMIT_SCREENER = gql`
  mutation SubmitScreener($id: ID!, $result: String!, $answer: [answersInput]) {
    screen: submitScreener(id: $id, result: $result, answer: $answer) {
      message
      photo
    }
  }
`

export const GET_APP_REWARDS = gql`
  mutation awardPoints($userId: ID!, $reason: String!) {
    awardUser(userId: $userId, reason: $reason) {
      success
    }
  }
`
export const UPDATE_SCRATCH_CARD_REWARDS = gql`
  mutation updateUserPoints($userId: ID!, $challengeId: ID!, $result: Boolean) {
    completeChallenge(
      userId: $userId
      challengeId: $challengeId
      result: $result
    ) {
      success
    }
  }
`

export const SUBMIT_TIMEDATA = gql`
  mutation pullTimeData(
    $userId: ID!
    $type: String!
    $time: Float!
    $_id: ID
    $month: Int
  ) {
    pullTimeData(
      userId: $userId
      type: $type
      _id: $_id
      time: $time
      month: $month
    ) {
      age
    }
  }
`
export const SEND_WORKSHEET_DATA = gql`
  mutation sendWorksheetData($userId: ID!, $sheetId: ID!, $status: String) {
    pullData(userId: $userId, sheetId: $sheetId, status: $status) {
      age
    }
  }
`

export const SEND_QUIZ_DATA = gql`
  mutation sendQuizData($userId: ID!, $questionId: ID!, $status: String) {
    pullQuizData(userId: $userId, questionId: $questionId, status: $status) {
      age
    }
  }
`

export const SEND_ASSESSMENT_DATA = gql`
  mutation sendAssessmentData($userId: ID!, $sheetId: ID!, $status: String) {
    pullAssesData(userId: $userId, sheetId: $sheetId, status: $status) {
      age
    }
  }
`

export const SEND_BONUS_DATA = gql`
  mutation sendBonusActivityData($userId: ID!, $activityType: String) {
    pullBonusData(userId: $userId, activityType: $activityType) {
      age
    }
  }
`

export const SEND_VIDEOS_DATA = gql`
  mutation senddVideoData($userId: ID!, $videoId: ID!, $status: String) {
    pullVideoData(userId: $userId, videoId: $videoId, status: $status) {
      age
    }
  }
`

export const SEND_PARENT_DATA = gql`
  mutation sendParentData($userId: ID!, $screenerId: ID!, $status: String) {
    pullParentsData(userId: $userId, screenerId: $screenerId, status: $status) {
      age
    }
  }
`
